import Link from "@/03-presenters/widgets/LinkWithCountryCode";
import { CategoryDashboardIcon, DashboardIcon, ProductDashboardIcon, ProductIcon, ShopIcon, CreatorIcon, VideoIcon, AdsIcon, LiveIcon, ShopifyIcon, LightDashboardIcon, LightCategoryDashboardIcon, LightProductDashboardIcon, LightProductIcon, LightShopIcon, LightCreatorIcon, LightVideoIcon, LightLiveIcon, LightAdsIcon, LightShopifyIcon, ShopDashboardIcon, LightShopDashboardIcon } from "./NavigationIcon";
import { cx } from "class-variance-authority";
import { openTitleStore } from "./Navigation";
const tiktokEntityList = [{
  title: "TikTok 大盘",
  icon: <DashboardIcon />,
  lightIcon: <LightDashboardIcon />,
  subItems: [{
    title: "品类大盘",
    href: "/tiktok/dashboard/category-dashboard",
    icon: <CategoryDashboardIcon />,
    lightIcon: <LightCategoryDashboardIcon />
  }, {
    title: "商品大盘",
    href: "/tiktok/dashboard/product-dashboard",
    icon: <ProductDashboardIcon />,
    lightIcon: <LightProductDashboardIcon />
  }, {
    title: "店铺大盘",
    href: "/tiktok/dashboard/seller-dashboard",
    icon: <ShopDashboardIcon />,
    lightIcon: <LightShopDashboardIcon />
  }],
  href: "/tiktok/dashboard/product-dashboard",
  isDashBoard: true
}, {
  title: "选爆品",
  icon: <ProductIcon />,
  lightIcon: <LightProductIcon />,
  href: "/tiktok/entity/tiktok_product/search",
  subItems: [{
    title: "商品搜索",
    href: "/tiktok/entity/tiktok_product/search"
  }, {
    title: "销量榜",
    href: "/tiktok/entity/tiktok_product/product_sold_count_view"
  }, {
    title: "热推榜",
    href: "/tiktok/entity/tiktok_product/product_promotion_view"
  }, {
    title: "新品榜",
    href: "/tiktok/entity/tiktok_product/new_product_view"
  }, {
    title: "历史同期榜",
    href: "/tiktok/entity/tiktok_product/product_history_view"
  }]
}, {
  title: "看竞店",
  subItems: [{
    title: "店铺搜索",
    href: "/tiktok/entity/tiktok_seller/search"
  }, {
    title: "销量榜",
    href: "/tiktok/entity/tiktok_seller/shop_sold_count_view"
  }, {
    title: "热推榜",
    href: "/tiktok/entity/tiktok_seller/shop_most_promoted_view"
  }],
  href: "/tiktok/entity/tiktok_seller/search",
  icon: <ShopIcon />,
  lightIcon: <LightShopIcon />
}, {
  title: "找达人",
  subItems: [{
    title: "达人搜索",
    href: "/tiktok/entity/tiktok_creator/search"
  }, {
    title: "涨粉达人榜",
    href: "/tiktok/entity/tiktok_creator/creator_fans_growth_view"
  }, {
    title: "带货达人榜",
    href: "/tiktok/entity/tiktok_creator/creator_ecommerce_creators_view"
  }, {
    title: "达人机构榜",
    href: "/tiktok/dashboard/agency-dashboard"
  }],
  href: "/tiktok/entity/tiktok_creator/search",
  icon: <CreatorIcon />,
  lightIcon: <LightCreatorIcon />
}, {
  title: "找视频",
  subItems: [{
    title: "视频搜索",
    href: "/tiktok/entity/tiktok_video/search"
  }],
  href: "/tiktok/entity/tiktok_video/search",
  icon: <VideoIcon />,
  lightIcon: <LightVideoIcon />
}, {
  title: "找直播",
  subItems: [{
    title: "直播搜索",
    href: "/tiktok/entity/tiktok_live/search"
  }],
  href: "/tiktok/entity/tiktok_live/search",
  icon: <LiveIcon />,
  lightIcon: <LightLiveIcon />
}, {
  title: "找广告",
  subItems: [{
    title: "广告库",
    href: "/tiktok/entity/tiktok_ads/search"
  }],
  href: "/tiktok/entity/tiktok_ads/search",
  icon: <AdsIcon />,
  lightIcon: <LightAdsIcon />
}];
const shopifyEntityList = [{
  title: "独立站数据",
  icon: <ShopifyIcon />,
  subItems: [{
    title: "Shopify 商品",
    href: "/shopify/entity/shopify_product/search"
  }, {
    title: "Shopify 店铺",
    href: "/shopify/entity/shopify_seller/search"
  }, {
    title: "Shopify 广告",
    href: "/shopify/entity/shopify_ads/search"
  }],
  href: "/shopify/entity/shopify_product/search",
  isDashBoard: true,
  lightIcon: <LightShopifyIcon />
}];
const DataInsightNavigationItem = ({
  href,
  icon,
  title,
  subItems,
  isDashBoard,
  isHomePage,
  lightIcon
}: {
  href: string;
  icon: React.ReactNode;
  lightIcon: React.ReactNode;
  title: string;
  subItems: {
    href: string;
    icon?: React.ReactNode;
    lightIcon?: React.ReactNode;
    title: string;
  }[];
  isDashBoard?: boolean;
  isHomePage?: boolean;
}) => {
  const dashBoardBg = isHomePage ? "bg-[linear-gradient(180deg,rgba(45,43,46,0.54)_0%,rgba(51,47,70,0.54)_100%)]" : "bg-[linear-gradient(180deg,#F6F7F9_0%,#F8F8FB_100%)]";
  const nonDashBoardBg = isHomePage ? "hover:bg-[linear-gradient(274deg,#3C3945_4.08%,#262332_99.47%)]" : "hover:bg-[#F4F5F9]";
  const tilteTextColor = isHomePage ? "text-white" : "text-[#000]";
  const subItemBg = isHomePage ? "hover:bg-[#3C3945]" : "hover:bg-[#EBEDF3]";
  const subItemTextColor = isHomePage ? "text-[#8C9296]" : "text-[#6F7E8B]";
  const subItemHoverTextColor = isHomePage ? "hover:text-[#E8E8E8]" : "hover:text-[#262B2F]";
  const setOpenTitle = openTitleStore(state => state.setOpenTitle);
  return <div className={cx("flex min-h-[188px] min-w-[116px] flex-col gap-2 rounded-md pb-2", isDashBoard && dashBoardBg)} onClick={() => {
    setOpenTitle(null);
  }} data-sentry-component="DataInsightNavigationItem" data-sentry-source-file="CustomDataInsight.tsx">
      <Link href={href} data-sentry-element="Link" data-sentry-source-file="CustomDataInsight.tsx">
        <div className={cx("flex items-center gap-2 rounded-sm p-2", !isDashBoard && nonDashBoardBg)}>
          {isHomePage ? icon : lightIcon}
          <div className={cx("text-sm", tilteTextColor)}>{title}</div>
          <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-source-file="CustomDataInsight.tsx">
            <path d="M3.85425 1.87506L6.97925 5.00006L3.85425 8.12506" stroke={isHomePage ? "white" : "#000"} strokeOpacity="0.4" strokeLinecap="round" strokeLinejoin="round" data-sentry-element="path" data-sentry-source-file="CustomDataInsight.tsx" />
          </svg>
        </div>
      </Link>
      <div className="flex flex-col gap-1.5 px-2">
        {subItems.map(subItem => <Link href={subItem.href} key={subItem.href}>
            <div className={cx("flex items-center gap-1.5 rounded-sm p-1.5", isDashBoard && subItemBg)}>
              {isHomePage ? subItem?.icon : subItem?.lightIcon}
              <span className={cx("text-sm", subItemTextColor, !isDashBoard && subItemHoverTextColor)}>
                {subItem.title}
              </span>
            </div>
          </Link>)}
      </div>
    </div>;
};
const TikTokDataInsightNavigation = ({
  isHomePage
}: {
  isHomePage?: boolean;
}) => {
  return <div className="flex gap-7" data-sentry-component="TikTokDataInsightNavigation" data-sentry-source-file="CustomDataInsight.tsx">
      {tiktokEntityList.map(item => <DataInsightNavigationItem isHomePage={isHomePage} key={item.href} {...item} />)}
    </div>;
};
const ShopifyDataInsightNavigation = ({
  isHomePage
}: {
  isHomePage?: boolean;
}) => {
  return <div className="flex gap-7" data-sentry-component="ShopifyDataInsightNavigation" data-sentry-source-file="CustomDataInsight.tsx">
      {shopifyEntityList.map(item => <DataInsightNavigationItem isHomePage={isHomePage} key={item.href} {...item} />)}
    </div>;
};
export default function CustomDataInsight({
  isHomePage
}: {
  isHomePage?: boolean;
}) {
  const splitLineColor = isHomePage ? "bg-[#454545]" : "bg-[#E5E6ED]";
  return <div className="ml-20 flex gap-8" data-sentry-component="CustomDataInsight" data-sentry-source-file="CustomDataInsight.tsx">
      <TikTokDataInsightNavigation isHomePage={isHomePage} data-sentry-element="TikTokDataInsightNavigation" data-sentry-source-file="CustomDataInsight.tsx" />
      <div className={cx("h-full w-px", splitLineColor)}></div>
      <ShopifyDataInsightNavigation isHomePage={isHomePage} data-sentry-element="ShopifyDataInsightNavigation" data-sentry-source-file="CustomDataInsight.tsx" />
    </div>;
}